<script lang="ts" setup>
interface HistoryEventsHeadlineProps {
  label: string;
  hierarchy: 3 | 4 | 5;
}

defineProps<HistoryEventsHeadlineProps>();
</script>

<template>
  <span>
    <component :is="`h${hierarchy}`" class="title text-body-2">{{ label }}</component>
    <hr v-if="hierarchy === 3" />
  </span>
</template>

<style lang="scss" scoped>
h3 {
  color: rgb(var(--v-theme-secondary));
  margin-bottom: 0;
}

h4 {
  font-size: 14px !important;
  font-style: italic;
  color: black;
  margin-top: 8px;
}

h5 {
  font-size: 12px !important;
  color: black;
  margin-bottom: 0;
}

hr {
  height: 1px;
  background-color: rgb(var(--v-theme-secondary-lighten-1));
  border: none;
  margin-bottom: 4px;
  margin-top: 4px;
}
</style>
